import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="content has-text-centered">
        <p>
          Created by <strong>Kushagr</strong>
        </p>
      </div>
    </footer>
  );
}
